export const TrustedDevicesTypes = {
  PIN: "pin-login",
  NATIVE_APP_BASE: "native-app-base",
};
